import DatePickerSystem from './DatePickerSystem';
import './DatePickerSystem.scss';

export default DatePickerSystem;
